import { useState } from "react";
import { FaQuestionCircle, FaChevronDown, FaChevronUp, FaEnvelope, FaGlobe, FaPhoneAlt } from "react-icons/fa";

export default function FaqsLanding() {
  // Maswali na Majibu yote yaliyotolewa (Static Data)
  const faqData = [
    {
      id: "faq-1",
      question: "Je ni viambatanisho gani vinahitajika ili niweze kupata mkopo wa dharura?",
      answer: "Ili mwanachama aweze kupata mkopo wa dharura anatakiwa ajaze fomu ya mkopo wa dharura kikamilifu, vile vile anatakiwa alipie ada ya kuchakata mkopo huo na hati ya malipo ya ada ya kuchakata iambatanishwe au akubali kukatwa ada ya kuchakata kutoka sehemu ya mkopo wake atakaopokea."
    },
    {
      id: "faq-2",
      question: "Je ni viambatanisho gani vinahitajika ili niweze kupata mkopo wa maendeleo?",
      answer: "Ili mwanachama aweze kupata mkopo wa maendeleo anatakiwa ajaze fomu ya maombi ya mkopo wa maendeleo kikamilifu, vile vile anatakiwa alipie ada ya kuchakata mkopo huo na hati ya malipo ya ada ya kuchakata iambatanishwe au akubali kukatwa ada ya kuchakata kutoka sehemu ya mkopo wake atakaopokea."
    },
    {
      id: "faq-3",
      question: "Je ninaweza kukopa mkopo wa dharura ikiwa bado nina mkopo mwingine wa dharura unaoendelea?",
      answer: "Mwanachama hawezi kukopa mkopo mwingine wa dharura kama ana mkopo mwingine wa dharura unaoendelea."
    },
    {
      id: "faq-4",
      question: "Je ninaruhusiwa kupunguza akiba mara ngapi kwa mwaka na ni kiasi gani naruhusiwa kupunguza?",
      answer: "Zoezi la kupunguza akiba bado linaendelea na lazima kuhakiksha salio lako ukilizidisha mara tatu liwe sawa au kubwa ya kiasi cha mkopo uliosalia kulipwa. Ingawa kwa sasa chama kinafikiria kuanzisha utaratibu wa akaunti ya amana ambapo mwanachama anaweza kuweka amana yake na kuitoa muda wowote atakaotaka kufanya hivyo."
    },
    {
      id: "faq-5",
      question: "Je kiasi nitakacho weka katika akaunti ya amana ninaweza kukitumia kama dhamna ya mkopo?",
      answer: "Kiasi utakachoweka katika akaunti ya amana hakiweza kutumika kama dhamana ya mkopo."
    },
    {
      id: "faq-6",
      question: "Je ninaweza kukopa mkopo wa maendeleo ikiwa nina mkopo wa dharura unaoendelea?",
      answer: "Mwanachama amaweza kukopa mkopo wa maendeleo hata kama ana mkopo wa dharura unaoendelea."
    }
  ];

  // State ya kudhibiti swali gani lipo wazi kwa wakati husika
  const [activeId, setActiveId] = useState(null);

  const toggleFaq = (id) => {
    setActiveId(activeId === id ? null : id);
  };

  return (
    <div className="ycsc-faqs-page bg-light pb-5 animate__animated animate__fadeIn">
      

      <div className="container mt-5 pt-2">
        <div className="row g-4 justify-content-center">
          
          {/* UPANDE WA KUSHOTO: ORODHA YA MASWALI NA MAJIBU */}
          <div className="col-lg-8">
            <div className="faq-section-header mb-4">
              <h3 className="font-semi-bold text-dark mb-2">Maswali Kuhusiana na Huduma Zetu</h3>
              <p className="text-muted small">Bonyeza swali lolote ili kusoma ufafanuzi na utaratibu wake rasmi.</p>
            </div>

            <div className="d-flex flex-column gap-3">
              {faqData.map((item, index) => {
                const isOpen = activeId === item.id;
                return (
                  <div 
                    key={item.id} 
                    className={`faq-premium-card card border-0 rounded-4 shadow-sm overflow-hidden transition-all ${isOpen ? 'faq-card-open' : ''}`}
                  >
                    {/* SEHEMU YA SWALI (HEADER) */}
                    <div 
                      className="faq-card-trigger d-flex justify-content-between align-items-center p-3 p-md-4 bg-white"
                      onClick={() => toggleFaq(item.id)}
                    >
                      <div className="d-flex align-items-center gap-3">
                        <span className="faq-number-badge font-bold text-primary bg-light rounded-circle d-flex align-items-center justify-content-center">
                          {index + 1}
                        </span>
                        <h5 className="faq-question-text font-semi-bold m-0 text-dark">
                          {item.question}
                        </h5>
                      </div>
                      <div className="faq-icon-wrapper ms-3 text-secondary">
                        {isOpen ? <FaChevronUp /> : <FaChevronDown />}
                      </div>
                    </div>

                    {/* SEHEMU YA JIBU (BODY) */}
                    <div className={`faq-card-body-wrapper ${isOpen ? 'd-block' : 'd-none'}`}>
                      <div className="faq-card-body p-3 p-md-4 bg-white border-top border-light">
                        <p className="faq-answer-text font-regular text-muted m-0">
                          {item.answer}
                        </p>
                      </div>
                    </div>

                  </div>
                );
              })}
            </div>
          </div>

          {/* UPANDE WA KULIA: MSAADA ZAIDI (SIDEBAR INFO CARD) */}
          <div className="col-lg-4">
            <div className="card border-0 rounded-4 shadow-sm bg-white p-4 sticky-lg-top faqs-sidebar-sticky">
              <div className="text-center mb-4">
                <div className="faq-help-icon-box bg-primary-subtle text-primary rounded-circle mx-auto d-flex align-items-center justify-content-center mb-3">
                  <FaQuestionCircle size={32} />
                </div>
                <h4 className="font-bold text-dark mb-2">Je, una swali jingine?</h4>
                <p className="text-muted small">Kama una maswali ya ziada au unahitaji msaada wa haraka, usisite kuwasiliana na timu yetu ya huduma kwa wateja.</p>
              </div>

              <hr className="text-secondary-subtle my-3" />

              {/* MAELEZO YA MAWASILIANO */}
              <div className="d-flex flex-column gap-3 pt-2">
                <a href="mailto:info@ycscsaccos.co.tz" className="faq-contact-item d-flex align-items-center gap-3 p-2 rounded-3 text-decoration-none text-secondary-dark">
                  <div className="icon-circle bg-light text-primary rounded-3 d-flex align-items-center justify-content-center">
                    <FaEnvelope />
                  </div>
                  <div className="contact-details min-w-0">
                    <span className="d-block text-muted tiny-label font-light">Barua Pepe</span>
                    <span className="d-block text-dark font-semi-bold text-truncate">info@ycscsaccos.co.tz</span>
                  </div>
                </a>

                <a href="https://www.ycscsaccos.co.tz" target="_blank" rel="noreferrer" className="faq-contact-item d-flex align-items-center gap-3 p-2 rounded-3 text-decoration-none text-secondary-dark">
                  <div className="icon-circle bg-light text-primary rounded-3 d-flex align-items-center justify-content-center">
                    <FaGlobe />
                  </div>
                  <div className="contact-details min-w-0">
                    <span className="d-block text-muted tiny-label font-light">Tovuti Rasmi</span>
                    <span className="d-block text-dark font-semi-bold text-truncate">www.ycscsaccos.co.tz</span>
                  </div>
                </a>
              </div>

              <div className="mt-4 bg-warning-subtle text-warning-dark p-3 rounded-3 text-center small font-semi-bold">
                "Mshikamano Daima"
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}